import { MenuItem } from '@mui/material'
import { CommentOnTaskDialogV2 } from 'components/pages/task/details/task-content-v2/common/CommentOnTaskDialogV2'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type CommentOnTaskDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const CommentOnTaskDropdownOption: FC<CommentOnTaskDropdownOptionProps> = ({ task, close }) => {
    const { open } = useSimpleModal()
    const handleClick = (): void => {
        open(CommentOnTaskDialogV2, { task })()
        close()
    }

    return (
        <MenuItem onClick={handleClick} key={`components_task_actions_dropdown_comment_task_${task.id}`}>
            <FormattedMessage id="components_task_actions_dropdown_comment_task" defaultMessage="Comment" />
        </MenuItem>
    )
}
